import React from 'react'

const NotFound = ({ location }) => (
  <div>
    <h2>Whoops</h2>
    <p>Sorry but {location.pathname} didn’t match any pages</p>
  </div>
)

export default NotFound



/** WEBPACK FOOTER **
 ** ./src/NotFound.js
 **/